import { useState } from "react";
import { deleteAddress } from "../../../../core/api/addresses/addresses";
import useUser from "../../../../core/user/useUser";
import useTranslations from "../../../../core/i18n/useTranslations";
import PrimeModal from "../../../../ui-lib/components/PrimeModal/PrimeModal";
import { notify } from "../../../../ui-lib/components/Alerts/Toast";
import { notifyApiErrors } from "../../../../core/helpers/helpers";

export const DeleteAddressModal = ({
  objectId,
  addressId,
  onClose,
  onDelete,
}: {
  objectId: string;
  addressId?: number;
  onClose: () => void;
  onDelete: () => void;
}) => {
  const t = useTranslations();
  const { authenticatedRequest } = useUser();

  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    if (!addressId) {
      return;
    }
    setLoading(true);
    try {
      await deleteAddress(objectId, addressId, authenticatedRequest);
      notify({
        message: t("Messages:delete_address_success"),
      });
      onDelete();
    } catch (error: any) {
      notifyApiErrors(error.response?.data?.errors);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PrimeModal
      withFooter
      withHeader
      loading={loading}
      header={t("Objects:delete_address")}
      isOpen={!!addressId}
      onClose={onClose}
      fixedWidth="576px"
      submitBtn={{ text: t("Objects:delete_address"), onClick: onSubmit }}
      cancelBtn={{ text: t("Common:cancel"), onClick: onClose }}
    >
      <p className="grey-600">{t("Messages:delete_address_confirm")}</p>
    </PrimeModal>
  );
};
